import axiosInstance from './axios'
import { AxiosResponse } from 'axios'

class ContactsService {

    constructor(private apiVersion: string = 'v1') {
    }

    public async getPersonsByContacts(filter: string): Promise<any> {
        try {
            return axiosInstance.get(`${this.apiVersion}/contacts/persons?contact=${filter}`)
                .then((response: AxiosResponse) => response.data)
        } catch (err: any) {
            throw new Error(err.message)
        }
    }
    public async getCompanyByContacts(filter: string): Promise<any> {
        try {
            return axiosInstance.get(`${this.apiVersion}/contacts/companies?contact=${filter}`)
                .then((response: AxiosResponse) => response.data)
        } catch (err: any) {
            throw new Error(err.message)
        }
    }
}

const contactsServices = new ContactsService()

export default contactsServices
